import { render } from "./EditarExperimentosView.vue?vue&type=template&id=574c0a89&scoped=true"
import script from "./EditarExperimentosView.vue?vue&type=script&lang=js"
export * from "./EditarExperimentosView.vue?vue&type=script&lang=js"

import "./EditarExperimentosView.vue?vue&type=style&index=0&id=574c0a89&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574c0a89"]])

export default __exports__